import React, {useContext} from 'react';
import {Link} from "react-router-dom";
import {useHistory} from "react-router-dom";
import {useAlert} from 'react-alert';
import {useFormik} from "formik";
import apiHelper from "../api/ApiHelper";
import {Redirect} from "react-router";
import {AuthContext} from "../providers/AuthProvider";
import {ForgotPasswordSchema} from "../common/types/Schemas";
import {BYInput} from "../common/inputs/BYInput";

const ForgotPassword = () => {
    const alert = useAlert();
    const history = useHistory();
    const {user} = useContext(AuthContext);

    const formik = useFormik({
        initialValues: {
            username: '',
        },
        validationSchema: ForgotPasswordSchema,
        validateOnMount: true,
        onSubmit: async (values) => {
            try {
                await apiHelper.resetPassword(values);
                alert.success('Mot de passe temporaire envoyé');
                history.push("/login");
            } catch (error) {
                const statusCode = error.response && error.response.status;

                if (statusCode === 404) {
                    alert.error('Mail non enregistré');
                } else {
                    alert.error(error.message);
                }
            }
        }
    });

    if (user) {
        return <Redirect to='/'/>
    }

    return (
        <section className="d-flex align-items-center">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-8 p-0 login-background d-none d-md-block"/>
                    <div className="col-md-4  p-md-5 p-4 background-white">

                        <form onSubmit={formik.handleSubmit}>
                            <div className="text-center">
                                <img
                                    className="logo-bi"
                                    src={process.env.PUBLIC_URL + '/img/logo.svg'}
                                    width={"260 px"}
                                    alt="Bouygues Immobilier logo"
                                />
                            </div>
                            <h3 className="text-center mb-4">Mot de passe oublié</h3>
                            <div className="mb-3">
                                <BYInput
                                    type="text"
                                    name="username"
                                    className="form-control"
                                    title="Identifiant"
                                    value={formik.values.username}
                                    onBlur={formik.handleBlur}
                                    onChange={formik.handleChange}
                                    required
                                    autoFocus
                                    touched={formik.touched.username}
                                    error={formik.errors.username}
                                />
                            </div>


                            <div className="d-flex mb-3 mt-5">

                                <button className="btn btn-secondary flex-grow-1"
                                        type="submit"
                                        disabled={!formik.isValid || formik.isSubmitting}>
                                    Envoyer
                                </button>
                            </div>
                            <Link className="btn btn-link d-block" to='/login'>Retour</Link>
                        </form>
                    </div>
                </div>
            </div>
        </section>
    );

};

export default ForgotPassword;
